import "./teams.css";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { PulseLoader } from "react-spinners";
import { CREATE_TEAM, TEAM_LIST } from "../../global/API";
import { Dropdown } from "primereact/dropdown";
import { useLocation, useNavigate } from "react-router-dom";
import { InputMask } from "primereact/inputmask";
import CustomModal from "../../components/customModal/customModal";
import InputField from "../../components/inputField/inputField";

const statusOptions = [
  { name: "All", value: 0 },
  { name: "Active", value: 1 },
  { name: "Inactive", value: 2 },
];

function Teams() {
  const [teamList, setTeamList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [statusFilter, setStatusFilter] = useState(0);
  const [selectedTeam, setSelectedTeam] = useState([]);
  const [filteredValues, setFilteredValues] = useState({ searchValue: "" });
  const [modifiedTeamDetails, setModifiedTeamDetails] = useState({});

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const fetchData = async () => {
    const { searchValue } = filteredValues;
    setIsLoading(true);
    const jwtToken = Cookies.get("jwtToken");

    const options = {
      method: "GET",
      headers: { Authorization: `Bearer ${jwtToken}`, Accept: "application/json" },
    };

    let query = `?limit=50&page=1&status=${statusFilter}`;

    if (filteredValues.searchValue) {
      query += `&search=${filteredValues.searchValue}`;
    }

    const URL = TEAM_LIST + query;
    try {
      const response = await fetch(URL, options);
      if (response.ok) {
        const data = await response.json();
        setTeamList(data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onHandleselectedList = (id, event) => {
    const newList = id;
    if (event.target.checked) {
      setSelectedTeam((preState) => [...preState, newList]);
    } else {
      const filteredListing = selectedTeam.filter((item) => item !== id);
      setSelectedTeam(filteredListing);
    }
  };

  const onHandleEvent = (event) => {
    const { name, value } = event.target;
    setModifiedTeamDetails((previousState) => ({ ...previousState, [name]: value }));
  };

  const onHandleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    Object.entries(modifiedTeamDetails).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        formData.append(key, value);
      }
    });

    try {
      const jwtToken = Cookies.get("jwtToken");
      const options = {
        method: "POST",
        body: formData,
        headers: { Authorization: `Bearer ${jwtToken}`, Accept: "application/json" },
      };
      const response = await fetch(CREATE_TEAM + selectedTeam[0], options);
      const data = await response.json();
      if (data.status === "Success") {
        setSelectedTeam([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const { searchValue } = filteredValues;
    if (searchValue?.length >= 3 || searchValue === "") {
      const timeout = setTimeout(() => {
        fetchData(1);
      }, 300);
      return () => clearTimeout(timeout);
    }
  }, [filteredValues.searchValue]);

  const filterGrid = (e) => {
    const { name, value } = e.target;
    setFilteredValues({
      ...filteredValues,
      [name]: value,
    });
  };

  useEffect(() => {
    fetchData();
  }, [statusFilter]);

  function formatUSPhoneNumber(number) {
    const cleaned = ("" + number).replace(/\D/g, "");
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      return `(${match[1]}) ${match[2]} ${match[3]}`;
    }

    return number;
  }

  const teamListView = () => {
    return teamList.data.map((teams) => {
      const { id, name, email, phone, status } = teams;
      return (
        <tr key={id}>
          <td>
            <div className="form-check">
              <input type="checkbox" className="form-check-input" onChange={(e) => onHandleselectedList(id, e)} checked={selectedTeam.includes(id)} />
              <label className="form-check-label"></label>
            </div>
          </td>
          <td>
            <div className="d-flex align-items-center gap-2">
              <div>
                <img src="/assets/images/dummy-person.png" alt="" style={{ objectFit: "cover", objectPosition: "top center" }} className="avatar-md full-rounded" />
              </div>
              <div>
                <a href="#!" className="text-dark fw-medium ">
                  {name}
                </a>
              </div>
            </div>
          </td>
          <td>
            {phone === "" ? (
              "--"
            ) : (
              <a href="tel:+1{phone}">
                {formatUSPhoneNumber(phone)} &nbsp; <i className="ri-phone-fill"></i>
              </a>
            )}
          </td>
          <td>
            <a href="mailto:{email}">
              {email} &nbsp; <i className="ri-mail-send-line"></i>
            </a>
          </td>
          <td>{status === 1 ? "Active" : "Inactive"}</td>
        </tr>
      );
    });
  };
  const teamsLoadingView = () => {
    return (
      <tr className="loading-hover">
        <td className="property-loader preloader">
          <PulseLoader color="#4180ad" />
        </td>
      </tr>
    );
  };
  const noTeamsView = () => {
    return (
      <tr className="loading-hover">
        <td className="no-data-found">
          <i className="ri-user-search-line fs-22 text-primary avatar-title"></i>
          No Team Member Found
        </td>
      </tr>
    );
  };
  const renderView = () => {
    if (isLoading) {
      return teamsLoadingView();
    } else if (teamList.status === "Not Found") {
      return noTeamsView();
    } else if (teamList.status === "Success") {
      return teamListView();
    }
  };

  const renderTeamEditing = () => {
    const { name, email, phone } = modifiedTeamDetails;

    return (
      <form onSubmit={onHandleSubmit}>
        <div className="mb-3">
          <label className="form-label">Name</label>
          <InputField type="name" name="name" className="form-control" onChange={onHandleEvent} value={name} />
        </div>
        <div className="mb-3">
          <label className="form-label">Email</label>
          <InputField type="email" name="email" className="form-control" onChange={onHandleEvent} value={email} />
        </div>
        <div className="mb-3">
          <label className="form-label">Phone</label>
          <InputMask mask="(999) 999 9999" name="phone" value={phone} onChange={onHandleEvent} className="form-control" />
        </div>
        <div className="mb-3">
          <label className="form-label">Status</label>
          <Dropdown className="custom-dropdown" value={statusFilter} options={statusOptions} optionLabel="name" appendTo={"self"} />
        </div>
        <div className="mb-3">
          <label className="form-label">Bio</label>
          <textarea rows={6} className="form-control"></textarea>
        </div>
        <div className="page-title-box">
          <button type="submit" className="btn btn-primary btn-blue">
            Submit
          </button>
        </div>
      </form>
    );
  };

  const handleReset = () => {
    setStatusFilter(0);
    setSelectedTeam([]);
    setFilteredValues({
      searchValue: "",
    });
  };

  return (
    <div className="page-content agents-page">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 ">
                Teams <span>({teamList.pagination !== undefined ? teamList.pagination.total : 0})</span>
              </h4>

              <div className="page-title-box-content">
                {selectedTeam.length > 0 && (
                  <button type="button" className="page-title-btn custom-target-icon fs-18">
                    <i className="ri-delete-bin-line"></i>
                  </button>
                )}
                {selectedTeam.length === 1 && (
                  <button
                    type="button"
                    className="page-title-btn custom-target-icon fs-18"
                    onClick={() => {
                      navigate(`edit/${selectedTeam[0]}`);
                      const selectedTeamData = teamList.data.filter((lead) => lead.id === selectedTeam[0])[0];
                      setModifiedTeamDetails(selectedTeamData);
                    }}
                  >
                    <i className="ri-edit-2-line"></i>
                  </button>
                )}
                <button type="button" className="page-title-btn refresh-button" title="Reset" onClick={handleReset}>
                  <i className="ri-refresh-line"></i>
                </button>
                <div className="app-search app-search-small">
                  <Dropdown value={statusFilter} onChange={(e) => setStatusFilter(e.value)} options={statusOptions} optionLabel="name" appendTo={"self"} />
                </div>

                <form className="app-search">
                  <div className="position-relative">
                    <input
                      type="search"
                      className="form-control border-0"
                      placeholder="Search..."
                      autoComplete="off"
                      value={filteredValues.searchValue || ""}
                      onChange={filterGrid}
                      name="searchValue"
                    />
                    <i className="ri-search-line search-widget-icon"></i>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="table-responsive">
                <table className="table align-middle text-nowrap table-hover table-centered property-table">
                  <thead className="bg-light-subtle">
                    <tr>
                      <th style={{ width: "10px" }}>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedTeam(teamList.data.map((lead) => lead.id));
                              } else {
                                setSelectedTeam([]);
                              }
                            }}
                            checked={teamList?.data?.length > 0 && selectedTeam.length === teamList.data.length}
                          />
                          <label className="form-check-label"></label>
                        </div>
                      </th>
                      <th>Photo & Name</th>
                      <th>Phone</th>
                      <th>Email</th>
                      <th>Stauts</th>
                    </tr>
                  </thead>
                  <tbody>{renderView()}</tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      {selectedTeam.length === 1 && (
        <CustomModal renderItem={renderTeamEditing} title="Edit Team" showHeader={true} position="right" visible={pathname.toLowerCase().includes(`edit/${selectedTeam[0]}`)} />
      )}
    </div>
  );
}

export default Teams;
